import {
  BestSellersOptionsItem,
  LowPriceOptionsItem,
  ProductFeaturedTitleItem,
  TProductRecommendType,
} from "../entitys";
import {
  ProductCardType,
  ProductZoneType,
  ProductLowType,
  ProductRankingType,
  ProductRecommendType,
} from "../enums";
import { Icon } from "@/components/Icons";
import type { SVGProps } from "react";

export const ProductRecommendTypeOptions: TProductRecommendType[] = [
  {
    msg: "ALL",
    href: "#all",
    value: ProductRecommendType.All,
  },
  {
    msg: "High Commission",
    href: "#highCommission",
    value: ProductRecommendType.HighCos,
  },
  {
    msg: "Best Selling",
    href: "#bestSelling",
    value: ProductRecommendType.Bestselling,
  },
];
interface IStatistics {
  number: string;
  title: string;
  icon?: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}
export const TotalStatistics: IStatistics[] = [
  {
    number: "400k+",
    title: "Creators",
    icon: Icon.UserWhite,
  },
  {
    number: "100k+",
    title: "Shop",
    icon: Icon.ShopWhite,
  },
  {
    number: "500k+",
    title: "Products",
    icon: Icon.ProductWhite,
  },
];

export const LastStatistics: IStatistics[] = [
  {
    number: "340k+",
    title: "Creators",
  },
  {
    number: "50k+",
    title: "Brand",
  },
  {
    number: "Brand",
    title: "Sold",
  },
];

export const BestSellersOptions: BestSellersOptionsItem[] = [
  {
    title: "24 Hours",
    value: ProductRankingType.Day,
  },
  {
    title: "7 Days",
    value: ProductRankingType.Week,
  },
];

export const ProductZoneTypeMap: Record<ProductZoneType, ProductCardType> = {
  [ProductZoneType.HighCommission]: ProductCardType.HighCommission,
  [ProductZoneType.BestSelling]: ProductCardType.BestSelling,
  [ProductZoneType.YouMayLike]: ProductCardType.YouMayLike,
};

export const FeaturedTitle: Record<ProductZoneType, ProductFeaturedTitleItem> =
  {
    [ProductZoneType.HighCommission]: {
      title: "High Commission",
      subtitle: "Get into high-commission sale",
      titleIcon: Icon.Wallet,
      url: "/recommended/" + ProductZoneType.HighCommission,
    },
    [ProductZoneType.BestSelling]: {
      title: "Best Match",
      subtitle: "Discover the best in Best Sellers",
      titleIcon: Icon.BestSelling,
      url: "/recommended/" + ProductZoneType.BestSelling,
    },
    [ProductZoneType.YouMayLike]: {
      title: "Latest",
      subtitle: "Your Picks Await",
      titleIcon: Icon.YouLike,
      url: "/recommended/" + ProductZoneType.YouMayLike,
    },
  };

export const LowPriceOptions: LowPriceOptionsItem[] = [
  {
    title: "28d sold",
    value: ProductLowType.sold,
  },
  {
    title: "Commission  Rate",
    value: ProductLowType.Rate,
  },
];
